import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EMPTY, Observable, ReplaySubject } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { UserConverter } from '../shared/helpers';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class CampaignService {
	private baseUrl: string;
	private _campaignStatus: ReplaySubject<boolean> = new ReplaySubject<boolean>();

	constructor(private httpClient: HttpClient, private matSnackBar: MatSnackBar) {
		this.baseUrl = environment.apiBaseUrl;
	}

	set isCampaignActive(value: boolean) {
		// Store the value
		this._campaignStatus.next(value);
	}

	get isCampaignActive$(): Observable<boolean> {
		return this._campaignStatus.asObservable();
	}

	createNewUser(user: any, campaignId = 1): Promise<any> {
		const data = UserConverter(user);
		return new Promise((resolve, reject) => {
			this.httpClient
				.post(this.baseUrl + `/api/campaigns/${campaignId}/responses`, data)
				.pipe(
					catchError((error: HttpErrorResponse) => {
						if (error && error.status !== 200 && error.status !== 201) {
							this.matSnackBar.open(
								'An error occurred while sending your request: ' + error.message,
								undefined,
								{
									duration: 4000,
									horizontalPosition: 'center',
									verticalPosition: 'top',
								},
							);

							return EMPTY;
						}
					}),
				)
				.subscribe((response: any) => {
					resolve(response);
				}, reject);
		});
	}

	getResources(): Observable<any> {
		return this.httpClient.get('assets/pdf/data.json');
	}
}
